import React, { useState, useEffect } from 'react';
import { Paper, Box, Typography } from "@mui/material";
import { typography } from "../../styles/globals.js";
import AddressCard from './AddressCard.js';
import GoogleStreetViewSimple from './GoogleStreetViewSimple.js';
import _ from "lodash";
import { colors } from '../../styles/globals.js';
import { AddAddressButton, RemoveAddressButton } from '../EditMode/CompanyDetailEditControls';

const AddressesTab = ({ addresses, onUpdateAddresses, graphData, onUpdateGraph, entityId }) => {
    // Sort addresses so input data appears first
    const sortedAddresses = _.sortBy(addresses || [], (address) => {
        const isInputData = address.association_type && address.association_type.includes('INPUT_DATA');
        return isInputData ? 0 : 1;
    });

    // State for selected address (default to first sorted address)
    const [selectedAddressId, setSelectedAddressId] = useState(sortedAddresses.length > 0 ? sortedAddresses[0].id : null);

    // Get the selected address for the street view
    const selectedAddress = sortedAddresses.find(addr => addr.id === selectedAddressId) || sortedAddresses[0];

    const handleAddressSelect = (addressId) => {
        setSelectedAddressId(addressId);
    };

    // Add key prop to force re-render when address changes
    const streetViewKey = selectedAddress?.id || selectedAddress?.value || selectedAddress?.fullAddress;

    if (!addresses || addresses.length === 0) {

        return (
            <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography sx={{ color: colors.textSecondary }}>
                    No addresses found
                </Typography>
                {onUpdateAddresses && (
                    <Box sx={{ mt: 2 }}>
                        <AddAddressButton addresses={addresses || []} onUpdate={onUpdateAddresses} graphData={graphData} onUpdateGraph={onUpdateGraph} entityId={entityId} />
                    </Box>
                )}
            </Box>
        );
    }

    return (
        <div>
            {onUpdateAddresses && (
                <Box sx={{ mb: 2 }}>
                    <AddAddressButton addresses={addresses} onUpdate={onUpdateAddresses} graphData={graphData} onUpdateGraph={onUpdateGraph} entityId={entityId} />
                </Box>
            )}
            <Box sx={{
                display: 'flex',
                gap: 3,
                '@media (max-width: 900px)': {
                    flexDirection: 'column'
                }
            }}>
                {/* Left Column - Google Street View */}
                <Box sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minWidth: 0
                }}>
                    {/* Address Title */}
                    <Typography sx={{
                        fontSize: '18px',
                        fontWeight: typography.fontWeights.semibold,
                        color: '#1a1a1a',
                        marginBottom: '16px',
                        lineHeight: 1.4
                    }}>
                    </Typography>

                    {/* Street View */}
                    <Box sx={{ flex: 1, minHeight: '550px' }}>
                        {selectedAddress && (
                            <GoogleStreetViewSimple
                                key={streetViewKey}
                                initialAddress={selectedAddress.value || selectedAddress.fullAddress}
                            />
                        )}
                    </Box>
                </Box>

                {/* Right Column - Address Cards */}
                <Box sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                    maxHeight: '600px',
                    overflowY: 'auto',
                    pr: 1,
                    pb: 2,
                    minWidth: 0
                }}>
                    {_.map(sortedAddresses, (address) => (
                        <Box key={address.id} sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5 }}>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <AddressCard
                                    address={address}
                                    isSelected={address.id === selectedAddressId}
                                    onSelect={() => handleAddressSelect(address.id)}
                                />
                            </Box>
                            {onUpdateAddresses && (
                                <RemoveAddressButton
                                    addressId={address.id}
                                    addresses={addresses}
                                    onUpdate={onUpdateAddresses}
                                />
                            )}
                        </Box>
                    ))}
                </Box>
            </Box>
        </div>
    );
};

export default AddressesTab;